import React, { useEffect, useState } from 'react';
import { useJoinClassroomUsingPin } from './api';
import VerifyDialog from './verify-dialog/VerifyDialog';

export interface JoinSimulationDialogProps {
  showDialog: boolean;
  reset: () => void;
}

const JoinSimulationDialog = ({ reset, showDialog }: JoinSimulationDialogProps) => {
  const [showJoinWithPin, setShowJoinWithPin] = useState(false);
  const [verifyingPin, setVerifyingPin] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const { joinClassroom } = useJoinClassroomUsingPin(
    () => {
      setVerifyingPin(false);
      setShowJoinWithPin(false);
      reset();
    },
    () => {
      setVerifyingPin(false);
      setErrorMessage('The code entered is invalid or may have expired. Please try again.');
    },
  );

  useEffect(() => setShowJoinWithPin(showDialog), [showDialog]);

  return (
    <VerifyDialog
      loading={verifyingPin}
      message="Join simulation"
      open={showJoinWithPin}
      onClose={() => {
        setShowJoinWithPin(false);
        setErrorMessage(undefined);
        reset();
      }}
      onConfirm={(pin: string) => {
        setVerifyingPin(true);
        joinClassroom(pin);

        return true;
      }}
      submitLabel="Join"
      errorMessage={errorMessage}
    />
  );
};

export default JoinSimulationDialog;
